import { useAppSelector } from "hooks/redux"
import { useAnalyticsWithProperties, type Analytics } from "connected-components/analytics/context"
import { useDashboardId } from "../context/dashboard-id"
import { DEFAULT_CORE_STATE } from "../store/core-slice"
import { useExtractDashboardContextProperties } from "./extract-context-properties"

// For callers above DashboardAnalyticsProvider but inside DashboardIdProvider; outside it, events silently scope to the "default" dashboard id
export function useDashboardAnalytics(): Analytics {
  const dashboardId = useDashboardId()
  const coreState = useAppSelector((s) => s.dashboard.core[dashboardId] ?? DEFAULT_CORE_STATE)
  const modelId = useAppSelector((s) => s.dashboard.model[dashboardId]?.modelId ?? null)

  // useExtractDashboardContextProperties memoizes on primitive fields, so no useMemo here
  const contextProperties = useExtractDashboardContextProperties({
    modelId,
    selectedMode: coreState.selectedMode,
    period: coreState.period,
    isIntraday: coreState.isIntraday,
    isEndVsStartDateComparison: coreState.isEndVsStartDateComparison,
    instrumentsMetadata: coreState.instrumentsMetadata,
    instrument: coreState.instrument,
    comparisonInstrument: coreState.comparisonInstrument,
    base: coreState.base,
    secondInstrument: coreState.secondInstrument,
  })

  return useAnalyticsWithProperties(contextProperties, "Dashboard")
}
